import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import React__default, { useRef, useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import useId from '../../hooks/useId/449a3fe82a3de04228b156fb9c192c6eb54d1aa31378ed8af87c1128d2309698.cfe-internal.js';
import { useMenuContext, MenuContextProvider } from './parts/9aa735e99888115d1f2d0425969a4994a74f07b331a0166f0611f0c1f50d3a1a.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/ab9ed2b21c82580ec784a93d344c77c1672a9cc3db9dc12c3175fa65e7ce419c.cfe-internal.js';
import useLatest from '../../hooks/useLatest/70d83229838d1f1f54143abcad3f88dcc130955a0eeb4036f7b0531864f0de79.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/902514ef45e755459db44cc1406ebbd6e3e7419aefe5d7bc91c709499b75773f.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/23c80f7add1e49cb7ec4f51c7147fefad38efa28a6c83d021f7f4e40fcc22e85.cfe-internal.js';
import useClickOutsidePortals from '../../hooks/useClickOutsidePortals/e2085e2f87aa843c8fdb6cfb14c34e00fb6be74f144acbbdf4cdc9ab978e2427.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/9ec064816ea12fff6e1a85a3a984bee573572d869469708abbe6afd1d77852e7.cfe-internal.js';
import SubmenuAnchor from './parts/3da57f71bf91f8f4c431e21a957bf68a72e5bdbc33b91760f43f57c5ba386bbe.cfe-internal.js';
import MenuAnchor from './parts/f6f854dfc179d9cba5bfb0328ff9d17a90e47b8b4bbbbb626f9ef3a4f20a545a.cfe-internal.js';
import MenuSpinner from './parts/024f03132dde997c09e8e376b0216639aabaef3e0230d9dcbe02316eb818789e.cfe-internal.js';
import MenuItem from './parts/2ce626f5e7e2c7b2b61e18f5d380e11bc27e0a8d7081b9e8d4d2c68d86b1b0c7.cfe-internal.js';
import Popper from '../../utils/Popper/aeef6e9786e50e6fbdb8b39cd2ba1d3ee4bd2753d6ff7e99aa47e466071224d8.cfe-internal.js';
import ArrowNav from './parts/ArrowNav/752ab80f63088273781b3399b160eb504026bfb5bf28417219a597fe8ffd03d0.cfe-internal.js';
import MenuSearchBox from './parts/22740ec41a145d8af6012eba975137f522245a8cabd780eba272ede238cbfe20.cfe-internal.js';
import useTranslation from '../../utils/Translation/47d395f30036b487ef3ded6d813eeb8887878947654c2f6624000c7005c4dd94.cfe-internal.js';
import { SUBMENU_POPPER_OFFSET, FLYOUT_POPPER_OFFSET } from '../../utils/45f71cf1e17e207ef406aad1e7e1d5a2ce1f4ae4382fd00a84689b09e31968d3.cfe-internal.js';

var _excluded = ["anchor", "aria-label", "aria-labelledby", "children", "className", "defaultLabel", "defaultValue", "disabled", "highlightedIndex", "id", "label", "maxHeight", "menuType", "onClick", "onClickAway", "onHighlightedIndexChange", "onKeyDown", "onIsOpenChange", "onSelectedValueChange", "isOpen", "placement", "portalTarget", "searchable", "isSearchFilteringDisabled", "searchValue", "onSearchValueChange", "selectable", "selectedValue", "unstable_isLoading", "unstable_isMultiSelect", "isMultiSelect", "zIndex", "private_isClosedMenuOpenedOnAnchorClick", "private_isFirstElementHighlightedOnUserActivatedOpen"];
var BaseMenu = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _externalAnchor$props, _externalAnchor$props2, _useMenuContext, _externalAnchor$props3, _externalAnchor$props4, _context4, _externalAnchor$props5, _externalAnchor$props6, _context5, _externalAnchor$props7, _externalAnchor$props8, _externalAnchor$props9, _anchorRef$current;

  var externalAnchor = _ref.anchor,
      externalAriaLabel = _ref['aria-label'],
      externalAriaLabelledBy = _ref['aria-labelledby'],
      children = _ref.children,
      className = _ref.className,
      defaultLabel = _ref.defaultLabel,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      disabled = _ref.disabled,
      externalHighlightedIndex = _ref.highlightedIndex,
      externalId = _ref.id,
      label = _ref.label,
      maxHeight = _ref.maxHeight,
      menuType = _ref.menuType,
      onClick = _ref.onClick,
      onClickAway = _ref.onClickAway,
      onHighlightedIndexChange = _ref.onHighlightedIndexChange,
      onKeyDown = _ref.onKeyDown,
      onIsOpenChange = _ref.onIsOpenChange,
      onSelectedValueChange = _ref.onSelectedValueChange,
      externalIsOpen = _ref.isOpen,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      portalTarget = _ref.portalTarget,
      _ref$searchable = _ref.searchable,
      searchable = _ref$searchable === void 0 ? false : _ref$searchable,
      _ref$isSearchFilterin = _ref.isSearchFilteringDisabled,
      isSearchFilteringDisabled = _ref$isSearchFilterin === void 0 ? false : _ref$isSearchFilterin,
      externalSearchValue = _ref.searchValue,
      externalOnSearchValueChange = _ref.onSearchValueChange,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      externalSelectedValue = _ref.selectedValue,
      _ref$unstable_isLoadi = _ref.unstable_isLoading,
      unstable_isLoading = _ref$unstable_isLoadi === void 0 ? false : _ref$unstable_isLoadi,
      _ref$unstable_isMulti = _ref.unstable_isMultiSelect,
      unstable_isMultiSelect = _ref$unstable_isMulti === void 0 ? false : _ref$unstable_isMulti,
      _ref$isMultiSelect = _ref.isMultiSelect,
      isMultiSelect = _ref$isMultiSelect === void 0 ? unstable_isMultiSelect : _ref$isMultiSelect,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
      _ref$private_isClosed = _ref.private_isClosedMenuOpenedOnAnchorClick,
      private_isClosedMenuOpenedOnAnchorClick = _ref$private_isClosed === void 0 ? true : _ref$private_isClosed,
      _ref$private_isFirstE = _ref.private_isFirstElementHighlightedOnUserActivatedOpen,
      private_isFirstElementHighlightedOnUserActivatedOpen = _ref$private_isFirstE === void 0 ? true : _ref$private_isFirstE,
      rest = _objectWithoutProperties(_ref, _excluded);

  var anchorId = useId((_externalAnchor$props = externalAnchor === null || externalAnchor === void 0 ? void 0 : (_externalAnchor$props2 = externalAnchor.props) === null || _externalAnchor$props2 === void 0 ? void 0 : _externalAnchor$props2.id) !== null && _externalAnchor$props !== void 0 ? _externalAnchor$props : externalId);
  var arrowNavId = "".concat(anchorId, "-menu");
  var parentCloseAndFocusAnchor = (_useMenuContext = useMenuContext()) === null || _useMenuContext === void 0 ? void 0 : _useMenuContext.closeAndFocusAnchor;
  var isSubmenu = Boolean(parentCloseAndFocusAnchor);

  var _useTranslation = useTranslation(),
      translate = _useTranslation.translate;

  var noMenuItemsToDisplayText = translate('menu.noItemsToDisplay');
  var anchorRef = useRef(null);

  var _useControllableState = useControllableState(false, onIsOpenChange, externalIsOpen),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      isOpen = _useControllableState2[0],
      setIsOpen = _useControllableState2[1];

  var _useControllableState3 = useControllableState(-1, onHighlightedIndexChange, externalHighlightedIndex),
      _useControllableState4 = _slicedToArray(_useControllableState3, 2),
      highlightedIndex = _useControllableState4[0],
      setHighlightedIndex = _useControllableState4[1];

  var _useControllableState5 = useControllableState(defaultValue, onSelectedValueChange, externalSelectedValue),
      _useControllableState6 = _slicedToArray(_useControllableState5, 2),
      selectedValue = _useControllableState6[0],
      setSelectedValue = _useControllableState6[1];

  var _useControllableState7 = useControllableState('', externalOnSearchValueChange, externalSearchValue),
      _useControllableState8 = _slicedToArray(_useControllableState7, 2),
      searchTerm = _useControllableState8[0],
      setSearchTerm = _useControllableState8[1];

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      submenuHighlightedIndex = _useState2[0],
      setSubmenuHighlightedIndex = _useState2[1]; // These effects are needed for onIsOpenChange to work for submenus since the isOpen state is always controlled by the parent menu


  var onIsOpenChangeRef = useLatest(onIsOpenChange);
  var externalIsOpenRef = useLatest(externalIsOpen); // Call onIsOpenChange whenever externalIsOpen changes

  useDidUpdate(function () {
    if (isSubmenu) {
      var _onIsOpenChangeRef$cu;

      (_onIsOpenChangeRef$cu = onIsOpenChangeRef.current) === null || _onIsOpenChangeRef$cu === void 0 ? void 0 : _onIsOpenChangeRef$cu.call(onIsOpenChangeRef, externalIsOpen);
    }
  }, [externalIsOpen, onIsOpenChangeRef, isSubmenu]); // Call onIsOpenChange if open on mount or on unmount

  useEffect(function () {
    if (isSubmenu) {
      if (externalIsOpenRef.current) {
        var _onIsOpenChangeRef$cu2;

        (_onIsOpenChangeRef$cu2 = onIsOpenChangeRef.current) === null || _onIsOpenChangeRef$cu2 === void 0 ? void 0 : _onIsOpenChangeRef$cu2.call(onIsOpenChangeRef, true);
      }

      return function () {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (externalIsOpenRef.current) {
          var _onIsOpenChangeRef$cu3;

          // eslint-disable-next-line react-hooks/exhaustive-deps
          (_onIsOpenChangeRef$cu3 = onIsOpenChangeRef.current) === null || _onIsOpenChangeRef$cu3 === void 0 ? void 0 : _onIsOpenChangeRef$cu3.call(onIsOpenChangeRef, false);
        }
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  var closeMenu = useCallback(function () {
    setIsOpen(false);
    setHighlightedIndex(-1);
    setSubmenuHighlightedIndex(-1);
    setSearchTerm('');
  }, [setHighlightedIndex, setIsOpen, setSearchTerm]);

  var handleMultiSelectChange = function handleMultiSelectChange(item) {
    var _context;

    var arr = selectedValue || selectedValue === 0 ? _concatInstanceProperty(_context = []).call(_context, selectedValue) : [];

    var i = _findIndexInstanceProperty(arr).call(arr, function (v) {
      var _item$props;

      return v === (item === null || item === void 0 ? void 0 : (_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.value);
    });

    if (i !== -1) {
      _spliceInstanceProperty(arr).call(arr, i, 1);
    } else {
      var _item$props2;

      arr = union(arr, item === null || item === void 0 ? void 0 : (_item$props2 = item.props) === null || _item$props2 === void 0 ? void 0 : _item$props2.value);
    }

    setSelectedValue(arr, getLabelFromValue(children, arr), item);
  };

  var handleSubmenuOnSelectedValueChange = function handleSubmenuOnSelectedValueChange(value, label, item) {
    if (!selectable) return;

    if (isMultiSelect) {
      handleMultiSelectChange(item);
      return;
    }

    setSelectedValue(value, getLabelFromValue(children, value), item);
  };

  var handleItemSelected = function handleItemSelected(item) {
    var _item$props3;

    if (!selectable) {
      closeAndFocusAnchor();
      return;
    }

    var value = item === null || item === void 0 ? void 0 : (_item$props3 = item.props) === null || _item$props3 === void 0 ? void 0 : _item$props3.value;

    if (!value && value !== 0) {
      // eslint-disable-next-line no-console
      console.warn('<MenuItem> should have a "value" prop when used in a <SelectMenu>', item);
    }

    if (isMultiSelect) {
      handleMultiSelectChange(item);
      return;
    }

    setSelectedValue(value, getLabelFromValue(children, value), item);
    closeAndFocusAnchor();
  };

  var handleClickAway = useCallback(wrapEvent(onClickAway, closeMenu), []);
  var preventClickOutside = useClickOutsidePortals(handleClickAway, {
    disabled: isSubmenu
  });

  var handleAnchorClick = function handleAnchorClick() {
    if (isOpen) {
      setIsOpen(false);
    } else if (private_isClosedMenuOpenedOnAnchorClick) {
      setIsOpen(true);
      setHighlightedIndex(private_isFirstElementHighlightedOnUserActivatedOpen ? 0 : -1);
    }
  };

  var handleAnchorKeyDown = function handleAnchorKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
      e.preventDefault(); // prevent scroll

      setIsOpen(true);
      setHighlightedIndex(private_isFirstElementHighlightedOnUserActivatedOpen ? 0 : -1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // prevent scroll

      var lastIndex = React__default.Children.count(children) - (searchable ? 0 : 1);
      setIsOpen(true);
      setHighlightedIndex(lastIndex);
    } else if (e.key === 'Tab') {
      closeMenu();
    }
  };

  var menuItemIndex = searchable ? 1 : 0;

  var generateMenuItems = function generateMenuItems() {
    var _context2;

    return _mapInstanceProperty(_context2 = React__default.Children).call(_context2, filterItems(isSearchFilteringDisabled ? null : searchTerm, React__default.Children.toArray(children)), function (child) {
      var actualIndex = menuItemIndex;

      if (isType(child, menuType)) {
        menuItemIndex += 1;
        return /*#__PURE__*/React__default.cloneElement(child, {
          isOpen: actualIndex === highlightedIndex,
          isHighlighted: actualIndex === highlightedIndex,
          placement: 'right-start',
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === ' ') {
              setSubmenuHighlightedIndex(0);
              e.preventDefault(); // prevent scroll
            }
          },
          onClick: function onClick() {
            setSubmenuHighlightedIndex(0);
          },
          highlightedIndex: submenuHighlightedIndex,
          isMultiSelect: isMultiSelect,
          defaultValue: defaultValue,
          selectedValue: selectedValue,
          onHighlightedIndexChange: setSubmenuHighlightedIndex,
          onSelectedValueChange: handleSubmenuOnSelectedValueChange
        });
      }

      if ((child === null || child === void 0 ? void 0 : child.type) === MenuItem) {
        var _context3, _child$props, _child$props2;

        menuItemIndex += 1;
        return /*#__PURE__*/React__default.cloneElement(child, {
          isHighlighted: actualIndex === highlightedIndex,
          isSelected: selectable && typeof selectedValue !== 'undefined' && _Array$isArray(selectedValue) ? _includesInstanceProperty(_context3 = selectedValue).call(_context3, child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.value) : (child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.value) === selectedValue,
          onSelect: wrapEvent(child.props.onSelect, function () {
            handleItemSelected(child);
          }),
          isMultiSelect: isMultiSelect,
          isSelectable: selectable
        });
      }

      return child;
    });
  };

  var anchorLabel = label !== null && label !== void 0 ? label : getLabelFromValue(children, selectedValue);
  var menuAnchorLabel = anchorLabel !== null && anchorLabel !== void 0 ? anchorLabel : defaultLabel;
  var ariaLabelledBy = (_externalAnchor$props3 = externalAnchor === null || externalAnchor === void 0 ? void 0 : (_externalAnchor$props4 = externalAnchor.props) === null || _externalAnchor$props4 === void 0 ? void 0 : _externalAnchor$props4['aria-labelledby']) !== null && _externalAnchor$props3 !== void 0 ? _externalAnchor$props3 : externalAriaLabelledBy ? _concatInstanceProperty(_context4 = "".concat(externalAriaLabelledBy, " ")).call(_context4, anchorId) : undefined;
  var ariaLabel = (_externalAnchor$props5 = externalAnchor === null || externalAnchor === void 0 ? void 0 : (_externalAnchor$props6 = externalAnchor.props) === null || _externalAnchor$props6 === void 0 ? void 0 : _externalAnchor$props6['aria-label']) !== null && _externalAnchor$props5 !== void 0 ? _externalAnchor$props5 : externalAriaLabel && typeof menuAnchorLabel === 'string' ? _concatInstanceProperty(_context5 = "".concat(externalAriaLabel, " ")).call(_context5, menuAnchorLabel) : externalAriaLabel;
  var ariaExpanded = (externalAnchor === null || externalAnchor === void 0 ? void 0 : externalAnchor.props['aria-expanded']) !== undefined ? externalAnchor.props['aria-expanded'] : isOpen ? true : undefined;
  var actualAnchor = externalAnchor !== undefined ? /*#__PURE__*/React__default.cloneElement(externalAnchor, {
    ref: mergeRefs(ref, anchorRef, externalAnchor.ref),
    tabIndex: (_externalAnchor$props7 = externalAnchor.props.tabIndex) !== null && _externalAnchor$props7 !== void 0 ? _externalAnchor$props7 : 0,
    role: (_externalAnchor$props8 = externalAnchor.props.role) !== null && _externalAnchor$props8 !== void 0 ? _externalAnchor$props8 : 'button',
    id: anchorId,
    'aria-controls': isOpen ? arrowNavId : undefined,
    'aria-expanded': ariaExpanded,
    'aria-haspopup': 'menu',
    'aria-disabled': (_externalAnchor$props9 = externalAnchor.props['aria-disabled']) !== null && _externalAnchor$props9 !== void 0 ? _externalAnchor$props9 : disabled,
    'aria-labelledby': ariaLabelledBy,
    'aria-label': ariaLabel,
    onMouseDown: preventClickOutside,
    onClick: wrapEvent(externalAnchor.props.onClick, handleAnchorClick),
    onKeyDown: wrapEvent(externalAnchor.props.onKeyDown, handleAnchorKeyDown)
  }) : isSubmenu ? /*#__PURE__*/React__default.createElement(SubmenuAnchor, _extends({
    ref: mergeRefs(ref, anchorRef),
    label: label,
    id: anchorId,
    "aria-controls": isOpen ? arrowNavId : undefined,
    "aria-expanded": isOpen ? true : undefined,
    onClick: onClick,
    onKeyDown: onKeyDown,
    disabled: disabled,
    className: className
  }, rest)) : /*#__PURE__*/React__default.createElement(MenuAnchor, _extends({}, rest, {
    id: anchorId,
    "aria-controls": isOpen ? arrowNavId : undefined,
    "aria-expanded": isOpen ? true : undefined,
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel,
    ref: mergeRefs(ref, anchorRef),
    disabled: disabled,
    label: menuAnchorLabel,
    onMouseDown: preventClickOutside,
    onClick: wrapEvent(onClick, handleAnchorClick),
    onKeyDown: wrapEvent(onKeyDown, handleAnchorKeyDown),
    isOpen: isOpen,
    className: classNames(className, _defineProperty({}, styles.selected, anchorLabel))
  }));
  var closeAndFocusAnchor = useCallback(function () {
    closeMenu();
    anchorRef.current && anchorRef.current.focus();
    parentCloseAndFocusAnchor && parentCloseAndFocusAnchor();
  }, [closeMenu, parentCloseAndFocusAnchor]);
  var menuItems = unstable_isLoading ? [/*#__PURE__*/React__default.createElement(MenuSpinner, {
    key: "menu-loading"
  })] : generateMenuItems();
  var listItems = menuItems || [];

  if (!listItems.length) {
    listItems.push( /*#__PURE__*/React__default.createElement("div", {
      key: "no-list-items",
      className: styles.menuItem
    }, noMenuItemsToDisplayText));
  }

  var searchBoxRef = useRef();
  var arrowNavRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(MenuContextProvider, {
    value: {
      closeAndFocusAnchor: closeAndFocusAnchor,
      setIsOpen: setIsOpen,
      isOpen: isOpen,
      anchorRef: anchorRef,
      setHighlightedIndex: setHighlightedIndex
    }
  }, /*#__PURE__*/React__default.createElement(Popper, {
    open: !disabled && isOpen,
    placement: placement,
    portalTarget: portalTarget,
    anchor: actualAnchor,
    modifiers: [{
      name: 'offset',
      options: {
        offset: isSubmenu ? SUBMENU_POPPER_OFFSET : FLYOUT_POPPER_OFFSET
      }
    }],
    popper: /*#__PURE__*/React__default.createElement(ArrowNav, {
      id: arrowNavId,
      role: "menu",
      "aria-labelledby": anchorId,
      isNavItem: function isNavItem(child) {
        return (child === null || child === void 0 ? void 0 : child.type) === MenuItem || (child === null || child === void 0 ? void 0 : child.type) === MenuSearchBox || isType(child, menuType);
      },
      style: {
        zIndex: zIndex
      },
      menuItemContainerClass: styles.menuItemContainer,
      onMouseDown: preventClickOutside,
      className: styles.contentPane,
      highlightedIndex: highlightedIndex,
      maxHeight: maxHeight,
      minWidth: isSubmenu ? undefined : Math.min(350, Math.max(160, anchorRef === null || anchorRef === void 0 ? void 0 : (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.offsetWidth)),
      searchable: searchable,
      onHighlightedIndexChange: function onHighlightedIndexChange(i) {
        return setHighlightedIndex(i);
      },
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Escape') {
          e.stopPropagation(); // Prevent Escape key event from bubbling up

          if (isSubmenu) {
            // Only update the highlighted index for the current menu
            setHighlightedIndex(-1);
          } else {
            closeAndFocusAnchor();
          }
        } else if (e.key === 'Tab') {
          // For Tab, focus should be moved relative to anchor
          // (not menu container) so we focus anchor before browser moves focus
          closeAndFocusAnchor();
        } else if (e.key === 'ArrowLeft' && isSubmenu) {
          var _arrowNavRef$current;

          // Only update the highlighted index for the current menu (i.e. if the event bubbles up to a parent menu, don't update the highlighted index for the parent menu)
          if ((_arrowNavRef$current = arrowNavRef.current) !== null && _arrowNavRef$current !== void 0 && _arrowNavRef$current.contains(e.target) && e.target !== searchBoxRef.current) {
            setHighlightedIndex(-1);
          }
        }
      },
      isSubmenu: isSubmenu,
      searchBoxRef: searchBoxRef,
      anchorRef: anchorRef,
      ref: arrowNavRef
    }, listItems)
  }));
});

function filterItems(valueToFilterBy, items) {
  if (!valueToFilterBy) {
    return items;
  }

  var result = _filterInstanceProperty(items).call(items, function (item) {
    var searchTermLowerCase = valueToFilterBy.toLowerCase();

    if (typeof item.props.label === 'string') {
      var _context6;

      return _includesInstanceProperty(_context6 = item.props.label.toLowerCase()).call(_context6, searchTermLowerCase);
    }

    if (typeof item.props.children === 'string') {
      var _context7;

      return _includesInstanceProperty(_context7 = item.props.children.toLowerCase()).call(_context7, searchTermLowerCase);
    } // eslint-disable-next-line no-console


    console.warn("<MenuItem> not included in search results!\n        Ensure prop \"children\" is of type \"string\" or provide a \"label\" prop!", item);
    return false;
  });

  return result;
}

function getLabelFromValue(children, value) {
  var _getDescendent2, _getDescendent2$props;

  if (!value && value !== 0) return undefined;

  if (_Array$isArray(value)) {
    var _context8, _context9, _context10;

    return _filterInstanceProperty(_context8 = _mapInstanceProperty(_context9 = _concatInstanceProperty(_context10 = []).call(_context10, value)).call(_context9, function (v) {
      var _getDescendent, _getDescendent$props;

      return (_getDescendent = getDescendent(children, v)) === null || _getDescendent === void 0 ? void 0 : (_getDescendent$props = _getDescendent.props) === null || _getDescendent$props === void 0 ? void 0 : _getDescendent$props.children;
    })).call(_context8, function (label) {
      return label || label === 0;
    }).join(', ');
  }

  return (_getDescendent2 = getDescendent(children, value)) === null || _getDescendent2 === void 0 ? void 0 : (_getDescendent2$props = _getDescendent2.props) === null || _getDescendent2$props === void 0 ? void 0 : _getDescendent2$props.children;
} // Mega-hack to make nested defaultValue prop work


function getDescendent(children, value) {
  if (value === undefined) return null;
  var childArray = React__default.Children.toArray(children);

  for (var i = 0; i < childArray.length; i += 1) {
    var _child$props3, _child$props4;

    var child = childArray[i];

    if ((child === null || child === void 0 ? void 0 : child.type) === MenuItem && (child === null || child === void 0 ? void 0 : (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.value) === value) {
      return child;
    }

    if ((child === null || child === void 0 ? void 0 : child.type) !== MenuItem && child !== null && child !== void 0 && (_child$props4 = child.props) !== null && _child$props4 !== void 0 && _child$props4.children) {
      var descendent = getDescendent(child.props.children, value);

      if (descendent) {
        return descendent;
      }
    }
  }

  return null;
}

function union(arr1, arr2) {
  var _context11, _context12, _context13;

  return _reduceInstanceProperty(_context11 = _concatInstanceProperty(_context12 = _concatInstanceProperty(_context13 = []).call(_context13, arr1)).call(_context12, arr2)).call(_context11, function (result, current) {
    if (!_includesInstanceProperty(result).call(result, current)) {
      result.push(current);
    }

    return result;
  }, []);
}

function isType(element, type) {
  return element && element.type && element.type.render === type;
}

var BaseMenu$1 = BaseMenu;

export { BaseMenu$1 as default };
